import {gql} from "@apollo/client";

export const ProfileLanguage = gql`
    query ProfileLanguage {
        profile {
            id
            language
        }
    }`